import Vue from "vue";
export default {
  reactive(source, obj){
    return Object.entries(obj).forEach(([key, val]) => Vue.set(source, key, val));
  }
};